module.exports = __webpack_public_path__ + "img/sweden-mental-and-behavioural-disorders-male.b45faa83.png";